import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import ApiService from '../../services/ApiService'
import { showAlert } from '../../utility/SweetAlert'

const InteractorFundBankList = () => {
  const { t } = useTranslation()
  const [bankData, setBankData] = useState([])
  const [bankPages, setBankPages] = useState({
    currentPage: 1,
    limitProduct: 0,
    totalPages: 1,
    totalItem: 0,
  })
  const { account } = useSelector((state) => state.account)

  const bankList = useCallback(
    (payload = {}, loadingCallback = () => {}) => {
      const payloadRequest = {
        ...payload,
        keywords: { ...payload.keywords, account_uid: account.uid },
      }
      loadingCallback(true)
      ApiService.jsonRequest('/fund-account/bank-search', payloadRequest, (response) => {
        loadingCallback(false)
        if (response.status_code === 200) {
          const { pages } = response.data
          setBankPages({
            currentPage: pages.page,
            limitProduct: pages.limit,
            totalPages: pages.total_pages,
            totalItem: pages.total_items,
          })
          setBankData(response.data?.items)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: false,
          })
        }
      })
    },
    [account.uid, t],
  )

  const bankListPageless = useCallback(
    (payload = {}, loadingCallback = () => {}) => {
      const payloadRequest = {
        ...payload,
        account_uid: account.uid,
      }
      loadingCallback(true)
      ApiService.jsonRequest('/fund-account/bank-list', payloadRequest, (response) => {
        loadingCallback(false)
        if (response.status_code === 200) {
          setBankData(response.data)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: false,
          })
        }
      })
    },
    [account.uid, t],
  )

  const bankView = useCallback(
    (payload = {}, loadingCallback = () => {}) => {
      const payloadRequest = {
        ...payload,
      }
      loadingCallback(true)
      ApiService.jsonRequest('/fund-account/bank-view', payloadRequest, (response) => {
        loadingCallback(false)
        if (response.status_code === 200) {
          setBankData(response.data)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: false,
          })
        }
      })
    },
    [t],
  )

  return {
    bankList,
    bankListPageless,
    bankView,
    bankData,
    bankPages,
  }
}

export default InteractorFundBankList
